export default {
  namespaced: true,
  state: {
    needUpdateCalendar: false, //是否需要更新日历
    waterId: 0, //id
    cupType: 2, //水杯类型
    drinkData: null, //喝水数据
    needUpdate: false
  },
  getters: {},
  mutations: {
    setDrinkData(state, b) {
      state.drinkData = b || []
    },
    setWaterId(state, b) {
      state.waterId = b || 0
    },
    setCupType(state, b) {
      state.cupType = b
    },
    setNeedUpdate(state, b) {
      state.needUpdate = b
    },
    setNeedUpdateCalendar(state, b) {
      state.needUpdateCalendar = b
    }
  },
  actions: {}
}
